import client from './client.js';

export const createPayment = async (payload) => {
  const { data } = await client.post('/payments', payload);
  return data;
  // { id, method, status, gross_amount, net_amount, pix_qr_code, pix_copy_paste, boleto_url, ... }
};

export const getPayment = async (id) => {
  const { data } = await client.get(`/payments/${id}`);
  return data;
};
